(function () {
  'use strict';

  function istNow() { return new Date(Date.now() + (5.5 * 60 * 60 * 1000)); }
  function istDate() { const d = istNow(); const p = (n) => String(n).padStart(2, '0'); return d.getUTCFullYear() + '-' + p(d.getUTCMonth() + 1) + '-' + p(d.getUTCDate()); }
  function istMonth() { return istDate().slice(0, 7); }
  function istStamp() { const d = istNow(); const p = (n) => String(n).padStart(2, '0'); return d.getUTCFullYear() + '-' + p(d.getUTCMonth() + 1) + '-' + p(d.getUTCDate()) + 'T' + p(d.getUTCHours()) + ':' + p(d.getUTCMinutes()) + ':' + p(d.getUTCSeconds()) + '+05:30'; }

  const Api = {
    base: '', customerId: '',
    init(base, cid) { this.base = (base || '').replace(/\/$/, ''); this.customerId = cid || ''; },
    _headers(json) { const h = { 'X-Customer-Id': this.customerId, 'ngrok-skip-browser-warning': 'true' }; if (json) h['Content-Type'] = 'application/json'; return h; },
    async _do(path, opts) { const r = await fetch(this.base + path, opts); const t = await r.text(); let d = {}; try { d = t ? JSON.parse(t) : {}; } catch (e) {} if (!r.ok) throw new Error(d.message || ('HTTP ' + r.status)); return d; },
    habits(date) { return this._do('/api/habits?date=' + encodeURIComponent(date), { method: 'GET', headers: this._headers(false) }); },
    habitItem(date, sectionKey, itemKey, checked) { return this._do('/api/habits/item', { method: 'POST', headers: this._headers(true), body: JSON.stringify({ date, sectionKey, itemKey, checked }) }); },
    habitWater(date, glasses) { return this._do('/api/habits/water', { method: 'PUT', headers: this._headers(true), body: JSON.stringify({ date, glasses }) }); },
    habitSleep(date, hours) { return this._do('/api/habits/sleep', { method: 'PUT', headers: this._headers(true), body: JSON.stringify({ date, hours }) }); },
    streak(month) { return this._do('/api/streak?month=' + encodeURIComponent(month), { method: 'GET', headers: this._headers(false) }); },
    rewards() { return this._do('/api/rewards', { method: 'GET', headers: this._headers(false) }); },
    subscribeNotification(subscribe) { return this._do('/api/notifications/subscribe', { method: 'POST', headers: this._headers(true), body: JSON.stringify({ subscribe: !!subscribe }) }); },
  };

  const CT = {
    push(name, props) {
      try {
        const ct = window.clevertap;
        if (ct && ct.event && typeof ct.event.push === 'function') { ct.event.push(name, props || {}); console.log('[Academy CT] ✓ ' + name, props); } // TODO: remove after testing
        else console.warn('[Academy CT] ✗ (SDK not loaded) ' + name, props); // TODO: remove after testing
      } catch (e) {}
    },
  };

  function detectEnv() {
    let device = 'Desktop', browser = 'Other';
    try {
      const ua = navigator.userAgent || '';
      if (/iPad|Tablet/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua))) device = 'Tablet';
      else if (/Mobi|Android|iPhone|iPod/i.test(ua)) device = 'Mobile';
      if (/Edg\//i.test(ua)) browser = 'Edge'; else if (/OPR\//i.test(ua)) browser = 'Opera';
      else if (/Chrome\//i.test(ua)) browser = 'Chrome'; else if (/Firefox\//i.test(ua)) browser = 'Firefox';
      else if (/Safari\//i.test(ua)) browser = 'Safari';
    } catch (e) {}
    return { device, browser };
  }

  class AcademyHub extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      document.documentElement.classList.add('has-academy-hub');
      // Check customer_id passed from mobile app via URL query parameters or localStorage
      const urlParams = new URLSearchParams(window.location.search);
      let paramCustomerId = urlParams.get('customer_id') || urlParams.get('cid') || urlParams.get('shopify_customer_id') || '';
      try {
        if (paramCustomerId) {
          localStorage.setItem('ha_app_customer_id', paramCustomerId);
        } else {
          paramCustomerId = localStorage.getItem('ha_app_customer_id') || '';
        }
      } catch (e) {}

      let rawId = paramCustomerId || this.dataset.customerId || '';
      if (rawId && !rawId.startsWith('gid://')) {
        rawId = 'gid://shopify/Customer/' + rawId.trim();
      }

      this.customerId = rawId;
      this.loggedIn = (this.dataset.loggedIn === 'true') || !!this.customerId;
      Api.init(this.dataset.baseUrl, this.customerId);

      this.env = detectEnv();
      this.sessionId = this._sessionId();
      this.waterGoal = parseInt(this.dataset.waterGoal, 10) || 8;
      this.waterMl = parseInt(this.dataset.waterMl, 10) || 250;
      this.sleepGoal = parseFloat(this.dataset.sleepGoal) || 8;
      this.sleepMin = parseFloat(this.dataset.sleepMin) || 0;
      this.sleepMax = parseFloat(this.dataset.sleepMax) || 16;
      this.sleepStates = this._readSleepStates();

      this.state = { checked: new Set(), water: 0, sleep: 0 };
      this.currentTab = 'learn';
      this._loaded = { habits: false, rewards: false, streak: false };
      this.learnEl = document.querySelector('academy-app');
      this.navEl = this.querySelector('.hub-nav');
      this.badgeEl = this.querySelector('[data-streak-badge]');
      this.notifBadgeEl = this.querySelector('[data-notif-badge]');

      this._renderFlaskMarks();
      this._renderSleepTicks();
      this._renderWaterGoalPill();
      this._wireNav();
      this._wireStreak();
      this._wireNotif();
      this._wireHabits();
      this._watchLearnScreen();
      this._switchTab('learn', true);

      this._layout();
      this._onResize = () => this._layout();
      window.addEventListener('resize', this._onResize);
      window.addEventListener('load', this._onResize);
      setTimeout(() => this._layout(), 600);

      this._tabEnteredAt = Date.now();
      this._track('Academy Tabs Loaded', { 'Tab': 'learn', 'Habit Sections': this.querySelectorAll('[data-section-key]').length, 'Water Goal': this.waterGoal, 'Sleep Goal': this.sleepGoal });

      if (this.loggedIn) this._loadStreak();
    }
    disconnectedCallback() { window.removeEventListener('resize', this._onResize); window.removeEventListener('load', this._onResize); if (this._screenObs) this._screenObs.disconnect(); }

    _watchLearnScreen() {
      if (!this.learnEl || typeof MutationObserver === 'undefined') return;
      const update = () => {
        const active = this.learnEl.querySelector('.academy-screen--active');
        const key = (active && (active.dataset.screen || '')) || '';
        const onQuiz = key.indexOf('screen-quiz-') === 0;
        if (this.badgeEl) this.badgeEl.classList.toggle('is-hidden', onQuiz);
        if (this.notifBadgeEl) this.notifBadgeEl.classList.toggle('is-hidden', onQuiz);
      };
      this._screenObs = new MutationObserver(update);
      this._screenObs.observe(this.learnEl, { attributes: true, attributeFilter: ['class'], subtree: true });
      update();
    }

    _topOffset() {
      const urlParams = new URLSearchParams(window.location.search);
      const isApp = urlParams.has('is_app') || urlParams.has('app') || urlParams.has('webview') ||
                    urlParams.has('in_app') ||
                    document.body.classList.contains('is-app') ||
                    document.documentElement.classList.contains('is-app') ||
                    document.body.classList.contains('appbrew-theme');
      if (isApp) return 0;

      const sels = '#appbrew-download-banner-root,[id*="download-banner"],[class*="download-banner"],[class*="announcement"],[class*="app-download"],[class*="smart-banner"],.app-banner,#shopify-section-header,.section-header,header[role="banner"],.site-header,.header-wrapper,sticky-header,header.header,header';
      let total = 0;
      const chosen = [];
      document.querySelectorAll(sels).forEach((el) => {
        if (el.closest && el.closest('academy-hub')) return;
        const style = getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden' || el.offsetParent === null) return;
        const pos = style.position;
        if (pos !== 'fixed' && pos !== 'sticky') return;
        if (chosen.some((c) => c.contains(el) || el.contains(c))) return;
        const r = el.getBoundingClientRect();
        if (r.height > 0 && r.top < window.innerHeight * 0.5) { chosen.push(el); total += r.height; }
      });
      return Math.round(total);
    }

    _positionChrome() {
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const siteH = this._topOffset();
      const navH = (desktop && this.navEl) ? Math.round(this.navEl.getBoundingClientRect().height) || 50 : 0;
      this.style.setProperty('--hub-nav-top', siteH + 'px');
      const topPos = (siteH + (desktop ? navH : 0) + 14) + 'px';
      if (this.badgeEl) {
        this.badgeEl.style.position = 'fixed';
        this.badgeEl.style.top = topPos;
      }
      if (this.notifBadgeEl) {
        this.notifBadgeEl.style.position = 'fixed';
        this.notifBadgeEl.style.top = topPos;
      }
      return { desktop, navH };
    }

    _layout() {
      const { desktop, navH } = this._positionChrome();
      const pad = desktop ? navH + 'px' : '';
      if (this.learnEl) this.learnEl.style.paddingTop = pad;
      this.querySelectorAll('[data-pane]').forEach((p) => { p.style.paddingTop = pad; });
    }

    _sessionId() { try { const k = 'ha_session_id'; let id = sessionStorage.getItem(k); if (!id) { id = 'sess-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8); sessionStorage.setItem(k, id); } return id; } catch (e) { return 'sess-' + Date.now().toString(36); } }
    _track(name, extra) {
      const base = {
        'Customer ID': this.customerId || '',
        'Customer Name': this.dataset.customerName || '',
        'Customer Email': this.dataset.customerEmail || '',
        'Logged In': !!this.loggedIn,
        'Session ID': this.sessionId,
        'Page URL': location.href,
        'Referrer': document.referrer || '',
        'Device Type': this.env.device,
        'Browser': this.env.browser,
        'Timestamp': istStamp(),
        'Source': 'Skin Academy Web',
      };
      if (extra) Object.keys(extra).forEach((k) => { const v = extra[k]; if (v !== undefined && v !== null && v !== '') base[k] = v; });
      CT.push(name, base);
    }

    _readSleepStates() { try { return JSON.parse(this.querySelector('[data-sleep-states]').textContent || '[]').filter((x) => x).sort((a, b) => a.max - b.max); } catch (e) { return []; } }

    _sleepText(h) {
      let text = this.sleepStates.length ? this.sleepStates[0].text : '';
      for (const s of this.sleepStates) { if (s.max <= h) text = s.text; }
      return text;
    }

    _sleepEmoji(h) {
      if (!h || h <= 0) return '😴';
      let customEmoji = '';
      for (const s of this.sleepStates) {
        if (s.max <= h && s.emoji) customEmoji = s.emoji;
      }
      if (customEmoji) return customEmoji;

      if (h <= 3.5) return '😫';
      if (h < 5) return '🥱';
      if (h <= 6.5) return '😐';
      if (h <= 8.5) return '😊';
      return '🤩';
    }

    _renderSleepTicks() {
      const wrap = this.querySelector('[data-sleep-ticks]'); if (!wrap) return;
      const min = parseFloat(this.dataset.sleepMin) || 0;
      const span = (this.sleepMax - min) || 1;
      wrap.innerHTML = this.sleepStates.filter((s) => s.tick).map((s) => {
        const frac = Math.max(0, Math.min(1, (s.max - min) / span));
        return '<span class="hub-sleep-tick" style="left:calc(9px + ' + frac + ' * (100% - 18px))">' + s.max + 'H<br>' + s.tick + '</span>';
      }).join('');
    }

    _renderFlaskMarks() {
      const wrap = this.querySelector('[data-flask-marks]'); if (!wrap) return;
      let html = '';
      for (let i = 1; i <= 4; i++) {
        const glasses = Math.round(this.waterGoal * i / 4);
        const litres = (glasses * this.waterMl / 1000).toFixed(1);
        html += '<div class="hub-flask-mark" style="bottom:' + (i * 25) + '%"><span>' + litres + 'L (' + glasses + 'gl)</span></div>';
      }
      wrap.innerHTML = html;
    }

    _renderWaterGoalPill() { const el = this.querySelector('[data-water-goal-pill]'); if (el) { const l = (this.waterGoal * this.waterMl / 1000).toFixed(1); el.textContent = '🎯 ' + this.waterGoal + 'gl / ' + l + 'L'; } }

    _wireNav() { this.querySelectorAll('[data-tab]').forEach((btn) => btn.addEventListener('click', () => this._switchTab(btn.dataset.tab))); }
    _switchTab(tab, silent) {
      const prev = this.currentTab; this.currentTab = tab;
      this.querySelectorAll('[data-tab]').forEach((b) => b.classList.toggle('is-active', b.dataset.tab === tab));
      this.querySelectorAll('[data-pane]').forEach((p) => { p.hidden = p.dataset.pane !== tab; });
      if (this.learnEl) this.learnEl.style.display = (tab === 'learn') ? '' : 'none';
      window.scrollTo(0, 0);
      if (!silent) {
        const secs = Math.round((Date.now() - (this._tabEnteredAt || Date.now())) / 1000);
        if (prev && prev !== tab && secs > 0) this._track('Academy Tab Exited', { 'Tab': prev, 'Time Spent (s)': secs });
        this._track('Academy Tab Switched', { 'Tab': tab, 'Previous Tab': prev });
      }
      this._tabEnteredAt = Date.now();
      if (tab === 'habits' && !this._loaded.habits) this._loadHabits();
      if (tab === 'rewards' && !this._loaded.rewards) this._loadRewards();
    }

    _wireHabits() {
      this.querySelectorAll('[data-htab]').forEach((btn) => btn.addEventListener('click', () => this._switchHabTab(btn.dataset.htab)));
      this.querySelectorAll('.hub-hab-item').forEach((el) => {
        const toggle = () => this._toggleItem(el);
        el.addEventListener('click', toggle);
        el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
      });
      const minus = this.querySelector('[data-water-minus]'); const plus = this.querySelector('[data-water-plus]');
      if (minus) minus.addEventListener('click', () => this._adjustWater(-1));
      if (plus) plus.addEventListener('click', () => this._adjustWater(1));
      this.sleepSlider = this.querySelector('[data-sleep-slider]');
      if (this.sleepSlider) {
        this.sleepSlider.min = this.dataset.sleepMin || 0; this.sleepSlider.max = this.dataset.sleepMax || 16; this.sleepSlider.step = this.dataset.sleepStep || 0.5;
        this.sleepSlider.addEventListener('input', () => this._onSleepInput(parseFloat(this.sleepSlider.value)));
      }
    }
    _sectionKeyOf(el) { const p = el.closest('[data-hpanel]'); return (p && p.dataset.sectionKey) || ''; }
    _ck(sectionKey, itemKey) { return (sectionKey || '') + '::' + itemKey; }
    _ckOf(el) { return this._ck(this._sectionKeyOf(el), el.dataset.itemKey); }

    async _loadHabits() {
      this._loaded.habits = true;
      try {
        const d = await Api.habits(istDate());
        this.state.checked = this._parseChecked(d.checkedItems);
        this.state.water = d.water || 0; this.state.sleep = d.sleep || 0;
      } catch (e) { this._track('Academy Habits Load Failed', { 'Error': (e && e.message) || 'unknown' }); }
      this.querySelectorAll('.hub-hab-item').forEach((el) => el.classList.toggle('is-checked', this.state.checked.has(this._ckOf(el))));
      this._paintWater(); if (this.sleepSlider) this.sleepSlider.value = this.state.sleep; this._paintSleep(); this._updateProgress();
    }

    _parseChecked(list) {
      const set = new Set();
      (list || []).forEach((entry) => {
        if (entry && typeof entry === 'object') { set.add(this._ck(entry.sectionKey, entry.itemKey)); return; }
        this.querySelectorAll('.hub-hab-item[data-item-key="' + String(entry).replace(/"/g, '\\"') + '"]').forEach((el) => set.add(this._ckOf(el)));
      });
      return set;
    }

    _switchHabTab(id) {
      const prev = this._habTab; this._habTab = id;
      this.querySelectorAll('[data-htab]').forEach((b) => b.classList.toggle('is-active', b.dataset.htab === id));
      this.querySelectorAll('[data-hpanel]').forEach((p) => p.classList.toggle('is-active', p.dataset.hpanel === id));
      this._track('Academy Habits Section Viewed', { 'Section Key': id, 'Previous Section Key': prev });
    }
    _toggleItem(el) {
      const panel = el.closest('[data-hpanel]');
      const sectionKey = this._sectionKeyOf(el);
      const itemKey = el.dataset.itemKey;
      const ck = this._ck(sectionKey, itemKey);
      const now = !this.state.checked.has(ck);
      if (now) this.state.checked.add(ck); else this.state.checked.delete(ck);
      el.classList.toggle('is-checked', now);
      this._track(now ? 'Academy Habits Item Checked' : 'Academy Habits Item Unchecked', { 'Section Key': sectionKey, 'Section Name': panel && panel.dataset.sectionName, 'Item Key': itemKey, 'Item Label': el.dataset.itemLabel });
      this._updateProgress();
      this._save(() => Api.habitItem(istDate(), sectionKey, itemKey, now));
    }
    _adjustWater(delta) {
      const next = Math.max(0, Math.min(this.waterGoal, this.state.water + delta));
      if (next === this.state.water) return;
      this.state.water = next; this._paintWater();
      this._track('Academy Habits Water Logged', { 'Glasses': next, 'Goal': this.waterGoal, 'Goal Met': next >= this.waterGoal });
      this._updateProgress(); this._save(() => Api.habitWater(istDate(), next));
    }
    _onSleepInput(hours) {
      this.state.sleep = hours; this._paintSleep(); this._updateProgress();
      clearTimeout(this._sleepTimer);
      this._sleepTimer = setTimeout(() => { this._track('Academy Habits Sleep Logged', { 'Hours': hours, 'Goal': this.sleepGoal, 'Goal Met': hours >= this.sleepGoal }); this._save(() => Api.habitSleep(istDate(), hours)); }, 500);
    }
    _paintWater() {
      const fill = this.querySelector('[data-flask-fill]'); const num = this.querySelector('[data-water-num]');
      if (fill) fill.style.height = Math.min(100, Math.round(this.state.water / this.waterGoal * 100)) + '%';
      if (num) num.textContent = this.state.water;
    }
    _paintSleep() {
      const val = this.querySelector('[data-sleep-val]');
      const st = this.querySelector('[data-sleep-status]');
      const dial = this.querySelector('[data-sleep-emoji]');
      if (val) val.textContent = this.state.sleep + 'h';
      if (st) st.textContent = this._sleepText(this.state.sleep);
      if (dial) {
        const emoji = this._sleepEmoji(this.state.sleep);
        if (dial.textContent !== emoji) {
          dial.textContent = emoji;
          dial.style.transform = 'scale(1.2)';
          setTimeout(() => { dial.style.transform = 'scale(1)'; }, 150);
        }
      }
      if (this.sleepSlider) {
        const pct = Math.round(this.state.sleep / this.sleepMax * 100);
        this.sleepSlider.style.background = 'linear-gradient(to right, var(--ha-board) ' + pct + '%, var(--ha-surface-alt) ' + pct + '%)';
      }
    }

    _updateProgress() {
      const sections = this.querySelectorAll('[data-section-key]');
      let mAny = 0, eAny = 0, mAll = 0, eAll = 0;
      sections.forEach((sec) => {
        const items = Array.from(sec.querySelectorAll('.hub-hab-item'));
        const any = items.some((it) => this.state.checked.has(this._ckOf(it))) ? 1 : 0;
        const all = items.length > 0 && items.every((it) => this.state.checked.has(this._ckOf(it))) ? 1 : 0;
        if (sec.dataset.sectionKey === 'evening') { eAny = any; eAll = all; } else { mAny = any; mAll = all; }
      });
      const waterAny = this.state.water > 0 ? 1 : 0, sleepAny = this.state.sleep > 0 ? 1 : 0;
      const waterFull = this.state.water >= this.waterGoal ? 1 : 0, sleepFull = this.state.sleep >= this.sleepGoal ? 1 : 0;
      const done = mAny + eAny + waterAny + sleepAny;
      const bar = this.querySelector('[data-hab-pbar]'); const cnt = this.querySelector('[data-hab-count]');
      if (bar) bar.style.width = Math.round(done / 4 * 100) + '%';
      if (cnt) cnt.textContent = done + ' / 4';
      this.querySelectorAll('[data-htab]').forEach((b) => {
        let d = false;
        if (b.dataset.htab === 'morning') d = mAll === 1;
        else if (b.dataset.htab === 'evening') d = eAll === 1;
        else if (b.dataset.htab === 'hydration') d = waterFull === 1;
        else if (b.dataset.htab === 'sleep') d = sleepFull === 1;
        b.classList.toggle('is-done', d);
      });
      if (this._lastProgress !== done) {
        this._lastProgress = done;
        this._track('Academy Habits Progress Updated', {
          'Sections Done': done, 'Morning Done': !!mAny, 'Evening Done': !!eAny,
          'Hydration Done': !!waterAny, 'Sleep Done': !!sleepAny,
        });
        if (done === 4 && !this._allDoneFired) {
          this._allDoneFired = true;
          this._track('Academy Habits All Sections Completed', { 'Glasses': this.state.water, 'Sleep Hours': this.state.sleep });
        }
      }
    }
    _save(fn) {
      Promise.resolve().then(fn)
        .then((res) => { if (res && res.streak) this._applyStreakNums(res.streak); })
        .catch((err) => { this._track('Academy Habits Save Failed', { 'Error': (err && err.message) || 'unknown' }); });
    }

    _wireStreak() {
      const open = this.querySelector('[data-streak-open]'); const close = this.querySelector('[data-streak-close]'); const overlay = this.querySelector('[data-streak-overlay]');
      if (open) open.addEventListener('click', () => this._openStreak());
      if (close) close.addEventListener('click', () => this._closeStreak());
      if (overlay) overlay.addEventListener('click', () => this._closeStreak());
    }
    _wireNotif() {
      const open = this.querySelector('[data-notif-open]');
      const close = this.querySelector('[data-notif-close]');
      const overlay = this.querySelector('[data-notif-overlay]');

      if (open) open.addEventListener('click', () => this._openNotif());
      if (close) close.addEventListener('click', () => this._closeNotif());
      if (overlay) overlay.addEventListener('click', () => this._closeNotif());

      const input = this.querySelector('input[data-notif-key="courses"]');
      if (input) {
        input.addEventListener('change', async (e) => {
          const isChecked = e.target.checked;
          const name = 'New course & lecture notifications';
          input.disabled = true;

          try {
            await Api.subscribeNotification(isChecked);
            if (this.learnEl) this.learnEl.notificationSubscription = isChecked;

            const msg = isChecked ? (name + ' enabled ✓') : (name + ' disabled');
            this._track('Academy Notification Preference Changed', {
              'Notification Key': 'courses',
              'Notification Name': name,
              'Enabled': isChecked
            });
            this._showToast(msg);
          } catch (err) {
            input.checked = !isChecked; // Revert check state on error
            this._showToast('Could not save notification preference. Please try again.');
          } finally {
            input.disabled = false;
          }
        });
      }

      document.addEventListener('academy:dashboard-loaded', (e) => {
        this._syncNotifFromApp(e.detail && e.detail.notificationSubscription);
      });

      if (this.loggedIn) {
        this._syncNotifFromApp();
      }
    }

    _syncNotifFromApp(overrideVal) {
      if (!this.loggedIn) return;
      let isSubscribed = overrideVal;
      if (typeof isSubscribed !== 'boolean' && this.learnEl && typeof this.learnEl.notificationSubscription === 'boolean') {
        isSubscribed = this.learnEl.notificationSubscription;
      }
      if (typeof isSubscribed === 'boolean') {
        const input = this.querySelector('input[data-notif-key="courses"]');
        if (input) input.checked = isSubscribed;
      }
    }

    _openNotif() {
      const panel = this.querySelector('[data-notif-panel]');
      const overlay = this.querySelector('[data-notif-overlay]');
      if (overlay) overlay.hidden = false;
      if (panel) panel.hidden = false;
      document.body.classList.add('hub-lock');
      this._track('Academy Notifications Panel Opened');
      this._syncNotifFromApp();
    }

    _closeNotif() {
      const panel = this.querySelector('[data-notif-panel]');
      const overlay = this.querySelector('[data-notif-overlay]');
      if (panel) panel.hidden = true;
      if (overlay) overlay.hidden = true;
      document.body.classList.remove('hub-lock');
    }
    _showToast(msg) {
      try {
        const app = document.querySelector('academy-app');
        if (app && app.toast && typeof app.toast.show === 'function') {
          app.toast.show(msg);
          return;
        }
        const toast = document.querySelector('academy-toast');
        if (toast && typeof toast.show === 'function') {
          toast.show(msg);
        }
      } catch (e) {}
    }
    async _openStreak() {
      const panel = this.querySelector('[data-streak-panel]'); const overlay = this.querySelector('[data-streak-overlay]');
      if (overlay) overlay.hidden = false; if (panel) panel.hidden = false;
      document.body.classList.add('hub-lock');
      await this._loadStreak();
      const s = this.streakData || {};
      this._track('Academy Streak Viewed', { 'Current Streak': s.currentStreak || 0, 'Longest Streak': s.longestStreak || 0, 'Total Check-ins': s.totalCheckins || 0 });
    }
    _closeStreak() { const p = this.querySelector('[data-streak-panel]'); const o = this.querySelector('[data-streak-overlay]'); if (p) p.hidden = true; if (o) o.hidden = true; document.body.classList.remove('hub-lock'); }
    async _loadStreak() { try { this.streakData = await Api.streak(istMonth()); this._applyStreakNums(this.streakData); this._renderCalendar(this.streakData.activeDates || []); } catch (e) {} }
    _applyStreakNums(s) {
      if (!s) return;
      if (s.totalCheckins != null && this._prevCheckins != null && s.totalCheckins > this._prevCheckins) {
        this._track('Academy Habits Day Completed', { 'Current Streak': s.currentStreak, 'Longest Streak': s.longestStreak, 'Total Check-ins': s.totalCheckins });
      }
      if (s.totalCheckins != null) this._prevCheckins = s.totalCheckins;
      if (s.currentStreak != null) {
        const el = this.querySelector('[data-streak-num]');
        if (el) {
          const changed = el.textContent !== String(s.currentStreak);
          el.textContent = s.currentStreak;
          if (changed && this.badgeEl) {
            this.badgeEl.classList.remove('is-bump');
            void this.badgeEl.offsetWidth;
            this.badgeEl.classList.add('is-bump');
          }
        }
        const hn = this.querySelector('[data-hab-streaknum]'); if (hn) hn.textContent = s.currentStreak + (s.currentStreak === 1 ? ' day' : ' days');
      }
      if (s.longestStreak != null) { const el = this.querySelector('[data-streak-longest]'); if (el) el.textContent = s.longestStreak; }
      if (s.totalCheckins != null) { const el = this.querySelector('[data-streak-checkins]'); if (el) el.textContent = s.totalCheckins; }
    }
    _renderCalendar(activeDates) {
      const grid = this.querySelector('[data-streak-cal]'); if (!grid) return;
      const active = new Set(activeDates); const now = istNow();
      const y = now.getUTCFullYear(), m = now.getUTCMonth(), todayD = now.getUTCDate(), todayStr = istDate();
      const firstDow = new Date(Date.UTC(y, m, 1)).getUTCDay();
      const lead = (firstDow + 6) % 7;
      const days = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
      const p = (n) => String(n).padStart(2, '0');
      let html = '';
      for (let i = 0; i < lead; i++) html += '<div class="hub-cal-cell is-empty"></div>';
      for (let d = 1; d <= days; d++) {
        const ds = y + '-' + p(m + 1) + '-' + p(d);
        let cls = 'hub-cal-cell';
        if (ds === todayStr) cls += ' is-today';
        else if (active.has(ds)) cls += ' is-active';
        else if (d > todayD) cls += ' is-future';
        html += '<div class="' + cls + '">' + d + '</div>';
      }
      grid.innerHTML = html;
      const lbl = this.querySelector('[data-streak-monthlbl]');
      if (lbl) lbl.textContent = now.toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });
    }

    async _loadRewards() {
      this._loaded.rewards = true;
      try {
        const d = await Api.rewards();
        const total = this.querySelector('[data-rew-total]'); if (total) total.textContent = (d.hycash && d.hycash.total) || 0;
        this._renderLeaderboard(d.leaderboard || {});
        this._track('Academy Rewards Viewed', { 'HYcash Total': (d.hycash && d.hycash.total) || 0, 'Leaderboard Rank': d.leaderboard && d.leaderboard.you ? d.leaderboard.you.rank : undefined });
      } catch (e) { this._track('Academy Rewards Load Failed', { 'Error': (e && e.message) || 'unknown' }); }
    }
    _renderLeaderboard(lb) {
      const el = this.querySelector('[data-rew-lb]'); if (!el) return;
      const medalOf = (r) => r === 1 ? ['gold', '🥇'] : r === 2 ? ['silver', '🥈'] : r === 3 ? ['bronze', '🥉'] : ['', '#' + r];
      const you = lb.you || null;
      const youRank = you ? you.rank : null;
      const topArr = (lb.top || []).slice(0, 3);
      const rankCount = {};
      topArr.forEach((p) => { rankCount[p.rank] = (rankCount[p.rank] || 0) + 1; });
      const isYouEntry = (p) => {
        if (you && you.id != null && p.id != null) return String(p.id) === String(you.id);
        if (p.isYou === true) return true;
        if (youRank != null && p.rank === youRank && rankCount[youRank] === 1) return true;
        return false;
      };
      const youInTop = topArr.some(isYouEntry);

      const top = topArr.map((p) => {
        const isYou = isYouEntry(p);
        const m = medalOf(p.rank);
        const name = isYou ? ((you && you.name) || p.name || 'You') : (p.name || 'Learner');
        const tag = isYou ? '<span class="hub-lb-you-tag">YOU</span>' : '';
        const checkinVal = p.checkins != null ? p.checkins : (p.points != null ? p.points : 0);
        return '<div class="hub-lb-row' + (isYou ? ' is-you' : '') + '"><div class="hub-lb-rank ' + m[0] + '">' + m[1] + '</div>'
          + '<div class="hub-lb-av">' + (p.initials || '') + '</div>'
          + '<div class="hub-lb-name">' + name + tag + '</div>'
          + '<div class="hub-lb-pts">' + checkinVal + '</div></div>';
      }).join('');

      let youRow = '';
      if (you && !youInTop) {
        const m = medalOf(you.rank);
        const checkinVal = you.checkins != null ? you.checkins : (you.points != null ? you.points : 0);
        youRow = '<div class="hub-lb-row is-you"><div class="hub-lb-rank ' + m[0] + '">' + m[1] + '</div>'
          + '<div class="hub-lb-av">' + (you.initials || 'ME') + '</div>'
          + '<div class="hub-lb-name">' + (you.name || 'You') + '<span class="hub-lb-you-tag">YOU</span></div>'
          + '<div class="hub-lb-pts">' + checkinVal + '</div></div>';
      }
      el.innerHTML = (youRow ? youRow + '<div class="hub-lb-divider"></div>' : '') + top;
    }
  }

  if (!customElements.get('academy-hub')) customElements.define('academy-hub', AcademyHub);
})();
